var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TabelaComp',{attrs:{"tituloCard":"Entrada","items":_vm.getItemsEntrada(),"headers":_vm.headers,"tipo":"entrada","status":_vm.getStatusEntrada()}})
}
var staticRenderFns = []

export { render, staticRenderFns }